import React, { useRef, useState, forwardRef, useImperativeHandle } from 'react'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import server from '../../server'
import { ToastPopUp } from '../shared/utils'
import DeleteModal from '../shared/DeleteModal'

const DeleteCatalogueItem = forwardRef((props, ref) => {
  const [visible, setVisible] = useState(false)
  const [row, setRow] = useState(null)
  const toast = useRef(null)
  const { DeleteRef } = ref

  useImperativeHandle(DeleteRef, () => ({
    confirmDelete(r) {
      setRow(r)
      setVisible(true)
    },
  }))

  const hide = () => setVisible(false)

  const onConfirm = () => {
    if (!row?.id) {
      setVisible(false)
      return
    }
    server
      .delete(`/admin/catalogue-items/${row.id}`)
      .then(() => {
        ToastPopUp(toast, 'success', 'Removed', 'Catalogue row was soft-deleted.')
        props.getData()
      })
      .catch((e) => {
        ToastPopUp(
          toast,
          'error',
          'Error',
          e.response?.data?.message || 'Delete failed'
        )
      })
    setVisible(false)
    setRow(null)
  }

  const footer = (
    <>
      <Button label='No' icon='pi pi-times' outlined onClick={hide} />
      <Button label='Yes' icon='pi pi-check' severity='danger' onClick={onConfirm} />
    </>
  )

  const label =
    row?.itemDescription ||
    row?.retailUpcCode ||
    (row?.id != null ? `ID ${row.id}` : 'this row')

  return (
    <>
      <div className='card flex justify-content-center'>
        <Toast ref={toast} />
      </div>
      <DeleteModal
        state={visible}
        footer={footer}
        onHide={hide}
        deletedItem={row}
        name={label}
      />
    </>
  )
})

export default DeleteCatalogueItem
